
const svg = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 2H19V4L4 4V19H2V2ZM7 7H20V20H7V7ZM5 22V5H22V22H5Z" fill="currentColor"></path></svg>';export default svg;
    